import { getNamedCourseTabs } from "./normalizeCourseShape";

/**
 * @param {object | null | undefined} node
 * @returns {boolean}
 */
function temarioNodeHasArchivos(node) {
  if (!node || typeof node !== "object") {
    return false;
  }
  if (Array.isArray(node.archivos) && node.archivos.length > 0) {
    return true;
  }
  return temarioNodeListHasArchivos(node.hijos);
}

/**
 * @param {unknown} nodes
 * @returns {boolean}
 */
export function temarioNodeListHasArchivos(nodes) {
  if (!Array.isArray(nodes)) {
    return false;
  }
  return nodes.some((node) => temarioNodeHasArchivos(node));
}

/**
 * Picks the Documents tab that should be active so existing files can be reordered
 * without requiring a new upload.
 *
 * @param {string} current
 * @param {unknown} pestanasCurso
 * @param {Record<string, unknown> | null | undefined} bloquesContenido
 * @returns {string}
 */
export function resolveSelectedCourseTab(current, pestanasCurso, bloquesContenido) {
  const valid = getNamedCourseTabs(pestanasCurso);
  if (valid.length === 0) {
    return "";
  }
  const currentKey = typeof current === "string" ? current.trim() : "";
  if (valid.includes(currentKey)) {
    return currentKey;
  }
  const src = bloquesContenido && typeof bloquesContenido === "object" ? bloquesContenido : {};
  const withArchivos = valid.find((tab) => temarioNodeListHasArchivos(src[tab]));
  if (withArchivos) {
    return withArchivos;
  }
  const withNodes = valid.find((tab) => Array.isArray(src[tab]) && src[tab].length > 0);
  return withNodes || valid[0];
}
